// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"DashboardHeading_root__F8wYp"};